import { isInCoinsApp, isInGetApp } from './utils'
import { globalVariable } from '@/utils/exportVariable'
import { isJsonString } from '@/utils/tool'
import { skuDatasFormat } from './dataFormat'

const LoginWayMap = {
  google: 'login/google',
  facebook: 'login/facebook',
  vk: 'login/vk',
}

const ShareWayMap = {
  whatsapp: 'share/whatsapp',
  facebook: 'share/facebook',
  twitter: 'share/twitter',
  messenger: 'share/messenger',
  vk: 'share/vk',
  telegram: 'share/telegram',
}

let safe_insets_cache = null

// app内登录后native向webview种cookie
const appSetCookie = () => {
  const originalSetCookieEvent = window.setCookie
  window.setCookie = function (cookie) {
    if (
      originalSetCookieEvent &&
      typeof originalSetCookieEvent === 'function'
    ) {
      originalSetCookieEvent()
      return
    }
    document.cookie = cookie
  }
}

const callAppFunc = (funcName, ...params) => {
  let result = null
  if (!process.client) {
    return result
  }

  if (!isInCoinsApp()) {
    return result
  }

  if (window.CoinJsKit && window.CoinJsKit[funcName]) {
    // console.log('==>funcname', funcName)
    // console.log('===>params', params)
    result = window.CoinJsKit[funcName](...params)
    // console.log('==>result', result)
  }
  return result
}

// GetApps
const callGetAppFunc = (funcName, ...params) => {
  let result = null
  if (!process.client) {
    return result
  }

  if (!isInGetApp()) {
    return result
  }

  if (window.cloudGameBridge && window.cloudGameBridge[funcName]) {
    result = window.cloudGameBridge[funcName](...params)
  }
  return result
}

// open
export const tryToNative = ({ url, params }) => {
  return new Promise((resolve, reject) => {
    const { isApp } = globalVariable.store.state
    if (!isApp) {
      reject('is not app')
      return
    }

    if (!url) {
      reject('no url')
      return
    }

    try {
      callAppFunc('open', url, params)
    } catch (err) {
      reject('callAppFunc fail')
      return
    }

    resolve('success')
  })
}

// getApps
// 判断是否登录
export const getAppsLogin = () => {
  try {
    return callGetAppFunc('isLogin')
  } catch (error) {
    return null
  }
}

// getApps
// 获取登录的状态
export const callAppsLogin = () => {
  callGetAppFunc('login', '___callAppsLogin__')
  return new Promise((resolve) => {
    window.___callAppsLogin__ = function (res) {
      resolve(res)
    }
  })
}

// getApps
// 获取游戏时长的状态
export const callAppsfetchIdInfo = () => {
  callGetAppFunc(
    'fetchIdInfo',
    '___callAppsFetch__success',
    '___callAppsFetch__fail'
  )
  return new Promise((resolve, reject) => {
    window.___callAppsFetch__success = function (res) {
      resolve(res)
    }
    window.___callAppsFetch__fail = function (res) {
      reject(res)
    }
  })
}
// 获取登录用户信息
export const getAppUserInfo = (cb) => {
  let userInfoObj = {}

  try {
    const userInfo = callAppFunc('getUserInfo')
    userInfoObj = JSON.parse(userInfo) || {}
    const store = globalVariable?.store || {}
    store.commit(
      'setUserInfo',
      userInfoObj && userInfoObj.kicoinId ? userInfoObj : null
    )
  } catch (err) {
    // console.log(err)
  }

  cb && typeof cb === 'function' && cb(userInfoObj)
  return userInfoObj
}

// 登录
export const appLogin = () => {
  return new Promise((resolve, reject) => {
    try {
      callAppFunc('open', 'login', null)
      const originalEvent = window.checkAppLoginStatus
      window.checkAppLoginStatus = function () {
        if (originalEvent && typeof originalEvent === 'function') {
          originalEvent()
          return
        }
        resolve()
      }
      appSetCookie()
    } catch (error) {
      reject(error)
    }
  })
}

// 登录 指定方式
export const appLoginByWay = (type = 'google') => {
  return new Promise((resolve, reject) => {
    try {
      const loginWay = LoginWayMap[type] || 'login/google'
      callAppFunc('open', loginWay, null)
      const originalEvent = window.checkAppLoginStatus
      window.checkAppLoginStatus = function () {
        if (originalEvent && typeof originalEvent === 'function') {
          originalEvent()
          return
        }
        resolve()
      }
      appSetCookie()
    } catch (error) {
      reject(error)
    }
  })
}

// 登出
export const appLogout = (backHome = true) => {
  callAppFunc('postMessage', 'toplupe://logout')
  if (backHome) {
    tryToNative({
      url: 'home',
      params: null,
    })
  }
}

// 关闭侧边栏
export const hideAppSidebar = () => {
  callAppFunc('postMessage', 'toplupe://hideSidebar')
}

// 获取app版本
export const getAppVersion = () => {
  let version = ''

  try {
    version = callAppFunc('getAppVersion')
  } catch (err) {
    // console.log(err)
  }

  return version
}

// 标题栏展示状态
// 0普通模式 1全屏 2全屏带返回键
export const changeTitleBarMode = (mode = 0) => {
  try {
    callAppFunc('changeTitleBarMode', mode)
  } catch (err) {
    // console.log(err)
  }
}

// 获取状态栏边距
// "{"top": 0, "left":0,"right":0,"bottom":0}"
export const getSystemBarInsets = () => {
  if (safe_insets_cache) {
    return safe_insets_cache
  }

  try {
    const insets = callAppFunc('getSystemBarInsets')
    const position = JSON.parse(insets) || {}

    const topPX = (position && position.top) || 0
    const bottomPX = (position && position.bottom) || 0

    const radio = window.devicePixelRatio || 1

    const top = Math.ceil(topPX / radio) || 0
    const bottom = Math.ceil(bottomPX / radio) || 0

    return (safe_insets_cache = {
      top,
      bottom,
    })
  } catch (err) {
    // console.log(err)
  }

  return {
    top: 0,
    bottom: 0,
  }
}

// 以特定方式分享
export const appShareByWay = (type = 'facebook', params) => {
  return new Promise((resolve) => {
    const shareWay = ShareWayMap[type] || 'share/whatsapp'
    callAppFunc('open', shareWay, params)
    resolve()
  })
}

// 支付完成
export const appOnPayFinished = () => {
  callAppFunc('postMessage', 'onPayFinished')
}

// 侧边栏出现发起通知
export const registerAppShow = () => {
  const originalEvent = window.onAppear
  window.onAppear = function () {
    if (originalEvent && typeof originalEvent === 'function') {
      originalEvent()
    }
    const event = new Event('pageVisible')
    window && window.dispatchEvent(event)
  }
}

// 关闭当前webview
export const appCloseCurWebview = () => {
  callAppFunc('postMessage', 'toplupe://finishCurrentPage')
}

// 获取request baseUrl
export const appReqBaseUrl = () => {
  return callAppFunc('getApiHost') || ''
}

// 调用IAP SDK Native 公共方法
function IAPNativeCommmonFn(options = {}, callbackName) {
  const callbackFnNameMaps = {
    queryProductDetails: 'onQueryProductDetail',
    buyProduct: 'onBuyProduct',
  }
  const nativeFnNameMaps = {
    queryProductDetails: 'queryProductDetails',
    buyProduct: 'buyProduct',
  }
  const callback = callbackFnNameMaps[callbackName]
  options.callback = callback
  callAppFunc(nativeFnNameMaps[callbackName], JSON.stringify(options))

  const originalEvent = window[callback]
  return new Promise((resolve) => {
    window[callback] = function (res) {
      if (originalEvent && typeof originalEvent === 'function') {
        originalEvent()
      }
      resolve(res)
    }
  })
}
// 从IAP SDK查询商品详情
export const queryProductDetailsByIAP = (options = {}, isEmpty = false) => {
  const { source } = globalVariable.store.state
  if (!process.client || !isInCoinsApp() || source !== 'iap' || isEmpty) {
    return Promise.resolve([])
  }
  if (process.client) {
    return new Promise((resolve) => {
      return IAPNativeCommmonFn(options, 'queryProductDetails').then((res) => {
        window.console.log('queryProductDetails', options, res)
        if (res) {
          if (isJsonString(res)) {
            resolve(
              skuDatasFormat(
                (JSON.parse(res) || []).map((item) => {
                  if (isJsonString(item)) {
                    return JSON.parse(item)
                  }
                })
              )
            )
          } else {
            resolve([])
          }
        } else {
          resolve([])
        }
      })
    })
  }
}
// 在IAP SDK中购买商品
export const buyProductByIAP = (options = {}) => {
  if (!isInCoinsApp() || !process.client) {
    return
  }
  return new Promise((resolve) => {
    return IAPNativeCommmonFn(options, 'buyProduct').then((res) => {
      window.console.log('buyProduct', options, res)
      if (res && isJsonString(res)) {
        const datas = JSON.parse(res) || []
        resolve(
          datas.map((item) => {
            if (isJsonString(item)) {
              return JSON.parse(item)
            }
          })
        )
      } else {
        resolve([])
      }
    })
  })
}

// 控制webview是否可以返回
export const webviewAllowBack = (bool) => {
  try {
    callAppFunc('setAllowBack', bool)
  } catch (err) {
    // console.log(err)
  }
}

// app内是否关闭了用户体验优化
// result === true时，代表关闭
// 版本兼容：无该jsbridge，callAppFunc('isUserExperienceImprovementProgramClosed')返回null
export const isUserExpOptiClosed = () => {
  let result = false
  try {
    result = callAppFunc('isUserExperienceImprovementProgramClosed')
    if (result === null) {
      result = false
    }
  } catch (err) {
    // console.log(err)
    result = false
  }
  return result
}

// 改进用户体验计划选项发生改变
export const registerAppUserExpOptiChanged = () => {
  const originalEvent = window.onUserExperienceImprovementProgramChanged
  window.onUserExperienceImprovementProgramChanged = function (allowed) {
    if (originalEvent && typeof originalEvent === 'function') {
      originalEvent()
      return
    }
    const event = new CustomEvent('appUserExpOptiChanged', {
      detail: { allowed: allowed },
    })
    window && window.dispatchEvent(event)
  }
}

// 点击消息时调用
export const dismissAvatarMsgDot = () => {
  try {
    callAppFunc('dismissAvatarMsgDot')
  } catch (err) {
    // console.log(err)
  }
}

// iap点击toast时调用
export const dismissMsgDot = () => {
  return new Promise((resolve) => {
    const originalEvent = window.dismissMsgDot
    window.dismissMsgDot = function () {
      if (originalEvent && typeof originalEvent === 'function') {
        originalEvent()
      }
      resolve()
    }
  })
}
